import React, { Suspense } from "react";

import type { AdminChatMessageListProps } from "./AdminChatMessageListInner";

const LazyAdminChatMessageList = React.lazy(() =>
  import("./AdminChatMessageListInner").then((mod) => ({
    default: mod.AdminChatMessageList,
  })),
);

export const AdminChatMessageList = (props: AdminChatMessageListProps) => {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-0 min-w-0 flex-1 items-center justify-center p-6 text-sm text-slate-500">
          Loading conversation…
        </div>
      }
    >
      <LazyAdminChatMessageList {...props} />
    </Suspense>
  );
};

export type { AdminChatMessageListProps } from "./AdminChatMessageListInner";
